import dayjs from 'dayjs'
import * as R from 'ramda'
import {
  GetProfile,
  Location,
  Profile,
  reqGetProfile,
  reqUpdateProfile,
  ReqUpdateProfilePayload,
  UpdateProfile,
} from '@weblite/sahab-profile-action/profile'
import { profileStorage } from './storage'
import { request } from '$setup/ws'
import { getClientUserId } from '$logic/client-user'
import { showProfileCompletionWarning } from '$comp/modals/profile-completion-warning'
import { isClientsRoom } from '$logic/room'
import { dateWithOffset } from '$logic/client-device/time-offset.service'
import { showArmanemaNotifActivation } from '$comp/modals/armanema/notif-activation'
import { showArmanemaNotifBlocked } from '$comp/modals/armanema/notif-blocked'
import { isInTwa } from '$func/environmentInfo'
import { isMadreseTaaliProfileCompleted } from '$logic/profile/helper'

export function getProfile(): Profile {
  const profile = profileStorage.get()
  if (profile) return profile
  return {
    birthDate: '',
    gender: null,
    location: null,
    updatedAt: null,
    userId: getClientUserId(),
    tasks: [],
    fatherName: '',
    extra: null,
  }
}

export function getReadableLocation(location: Location) {
  return `${location.province}، ${location.county}`
}

export function getReadableBirthDate(birthDate: string) {
  // TODO
  return birthDate
}

function getAgeFromBirthDate(birthDate: string) {
  return dayjs(dateWithOffset()).diff(dayjs(birthDate), 'year')
}

function setProfileGAEvent() {
  if (!window.gtag) return

  const { gender, location, birthDate } = getProfile()

  const age = getAgeFromBirthDate(birthDate)
  const userProperties = {
    ...(gender && { gender }),
    ...location,
    ...(age && { age }),
  }
  if (!R.isEmpty(userProperties)) {
    window.gtag('set', 'user_properties', userProperties)
  }
}

export async function editProfile(profile: ReqUpdateProfilePayload['profile']) {
  const res = await request<UpdateProfile>(reqUpdateProfile({ profile }))
  if (res.error) {
    // TODO handle UI
    throw res.error.message
  }
  await profileStorage.set({ ...profile, ...res.payload })
  setProfileGAEvent()
}

export async function syncProfile(): Promise<void> {
  const res = await request<GetProfile>(reqGetProfile({}))
  await profileStorage.set(res.payload?.profile)

  setProfileGAEvent()
}

export const MADRESE_TAALI_MOGHAVEMAT_ROOMID =
  '9353429a-8908-4f74-a082-951715de4076'

export async function checkProfileOnOpenRoom(roomId: string) {
  if (import.meta.env.VITE_CHECK_ON_OPEN_SPECIFIC_ROOM === 'true')
    if (roomId === MADRESE_TAALI_MOGHAVEMAT_ROOMID && isClientsRoom(roomId)) {
      // #moghavemat
      const profile = profileStorage.get()
      if (!isMadreseTaaliProfileCompleted(profile)) {
        analite('SHOW_MADRESE_TAALI_PROFILE_COMPLETION_WARNING')
        showProfileCompletionWarning()
      } else {
        return
        if (isInTwa) {
          // TODO
        } else {
          if (window.Notification?.permission === 'denied') {
            analite('SHOW_SJF_NOTIF_BLOCKED')
            showArmanemaNotifBlocked()
          }
          if (window.Notification?.permission === 'default') {
            analite('SHOW_SJF_NOTIF_ACTIVATION')
            showArmanemaNotifActivation()
          }
        }
      }
    }
}
